export * from './responsive-manager';
